/**
 * LaptopIcon/index.js
 * desc: laptop icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LaptopIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="laptop icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.laptop.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg"><path d="M21.99 12c0 1.1-.89 2-1.99 2h4v2H0v-2h4c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2l-.01 10zM20 2H4v10h16V2z" /></svg>
    </IconButton>
);


export default LaptopIcon;
